@if(userLastFirstName()) {
  <div class="flex flex-row justify-between px-5 py-2 mb-6 bg-gray-600 text-white font-semibold tracking-widest w-full">
    <div>{{ userLastFirstName() | uppercase }}</div>
      @if(userRole()) {
        <div>{{ userRole() | uppercase }}</div>
      }
  </div>
} @else {
  <div class="p-3 mb-6 border border-red-600 text-red-600">ERROR: Selected User is NULL: Unable to render banner.</div>
}
